var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 26.03,
  viewBox: "0 0 18 26.03"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.712,0H.826A.576.576,0,0,0,.27.593V22.813a1.2,1.2,0,0,0,.6,1.056,1.056,1.056,0,0,0,1.158-.092l6.237-4.762,6.237,4.762a1.058,1.058,0,0,0,1.158.091,1.2,1.2,0,0,0,.605-1.056V.593A.576.576,0,0,0,15.712,0Zm0,0",
  transform: "translate(0.73 1)",
  fill: "#fbc52d",
  stroke: "#fbc512",
  strokeWidth: 2
})));
export default __webpack_public_path__ + "static/media/bookmark-active.b24e50e5.svg";
export { SvgComponent as ReactComponent };